module.exports = __webpack_public_path__ + "static/media/22-elleve.c3041b60.mp3";